/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReorderInitiativesRequest
 */
export interface ReorderInitiativesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReorderInitiativesRequest
     */
    orderedIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReorderInitiativesRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the ReorderInitiativesRequest interface.
 */
export function instanceOfReorderInitiativesRequest(value: object): value is ReorderInitiativesRequest {
    if (!('orderedIds' in value) || value['orderedIds'] === undefined) return false;
    return true;
}

export function ReorderInitiativesRequestFromJSON(json: any): ReorderInitiativesRequest {
    return ReorderInitiativesRequestFromJSONTyped(json, false);
}

export function ReorderInitiativesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderInitiativesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orderedIds': json['orderedIds'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function ReorderInitiativesRequestToJSON(json: any): ReorderInitiativesRequest {
    return ReorderInitiativesRequestToJSONTyped(json, false);
}

export function ReorderInitiativesRequestToJSONTyped(value?: ReorderInitiativesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderedIds': value['orderedIds'],
        'effectTenantId': value['effectTenantId'],
    };
}

